export {default} from './DeliverableXs';


// WEBPACK FOOTER //
// ./src/components/Project/DeliverableXs/index.js